/**
 * @generated SignedSource<<537c53382a186fdfaae5330e15224f27>>
 * @relayHash a36aa92fb425eba22e2c4c4524a6a14b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da3541a573579622f7cb7ee7e389ec716109499a504a799d078972baa18fa107

import type { ConcreteRequest } from 'relay-runtime';
export type useUnitLinkedResourceIdsQuery$variables = {
  id: string;
};
export type useUnitLinkedResourceIdsQuery$data = {
  readonly admin_unitLinkedResource: {
    readonly id: string;
    readonly links: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      }> | null;
    };
  } | null;
};
export type useUnitLinkedResourceIdsQuery = {
  response: useUnitLinkedResourceIdsQuery$data;
  variables: useUnitLinkedResourceIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AdminUnitLinkedResource",
    "kind": "LinkedField",
    "name": "admin_unitLinkedResource",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "AdminUnitLinkedConnection",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "concreteType": "AdminUnitLinkedEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AdminUnitLinkedTo",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUnitLinkedResourceIdsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUnitLinkedResourceIdsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "da3541a573579622f7cb7ee7e389ec716109499a504a799d078972baa18fa107",
    "metadata": {},
    "name": "useUnitLinkedResourceIdsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8a09c11bb6b98d6b2e8216fe9b58dc41";

export default node;
